import { EditListingFormStepId } from '../../core/listing/listing';
import { AppRoutes } from '../../core/routes/routes';

export const basePath = `brand`;

export const baseUrl = `/${basePath}`;

export const routes = {
  dashboard: {
    path: 'dashboard',
    url: () => `${baseUrl}/dashboard`,
  },
  inbox: {
    path: 'inbox',
    url: () => `${baseUrl}/inbox`,
  },
  applications: {
    path: 'applications',
    url: () => `${baseUrl}/applications`,
  },
  products: {
    index: {
      path: 'products',
      url: () => `${baseUrl}/products`,
    },
    create: {
      path: 'products/create',
      url: () => `${baseUrl}/products/create`,
    },
    edit: {
      path: 'products/edit/:id',
      url: (args: { id: string }) => `${baseUrl}/products/edit/${args.id}`,
    },
  },
  listing: {
    index: {
      path: 'listings',
      url: () => `${baseUrl}/listings`,
    },
    create: {
      path: 'listings/create',
      url: () => `${baseUrl}/listings/create`,
    },
    edit: {
      path: 'listings/edit/:listingId/:video/:stepId',
      url: (args: { listingId: string; video?: number; stepId?: EditListingFormStepId }) =>
        `${baseUrl}/listings/edit/${args.listingId}/${args.video ?? 0}/${args.stepId ?? 'video-details'}`,
    },
    detail: {
      root: {
        path: 'listings/:listingId',
        url: (args: { listingId: string }) => `${baseUrl}/listings/${args.listingId}`,
      },
      overview: {
        path: 'overview',
        url: (args: { listingId: string }) => `${baseUrl}/listings/${args.listingId}/overview`,
      },
      applications: {
        index: {
          path: 'applications',
          url: (args: { listingId: string }) => `${baseUrl}/listings/${args.listingId}/applications`,
        },
        detail: {
          path: 'listings/:listingId/applications/:applicationId',
          url: (args: { listingId: string; applicationId: string }) =>
            `${baseUrl}/listings/${args.listingId}/applications/${args.applicationId}`,
        },
      },
      creators: {
        path: 'creators',
        url: (args: { listingId: string }) => `${baseUrl}/listings/${args.listingId}/creators`,
      },
    },
    purchased: {
      path: 'listings/:listingId/purchased',
      url: (args: { listingId: string }) => `${baseUrl}/listings/${args.listingId}/purchased`,
    },
    orders: {
      detail: {
        root: {
          path: 'listings/:listingId/orders/:orderId',
          url: (args: { listingId: string; orderId: string }) => `${baseUrl}/listings/${args.listingId}/orders/${args.orderId}`,
        },
        overview: {
          path: 'overview',
          url: (args: { listingId: string; orderId: string }) => `${baseUrl}/listings/${args.listingId}/orders/${args.orderId}/overview`,
        },
        chat: {
          path: 'chat',
          url: (args: { listingId: string; orderId: string }) => `${baseUrl}/listings/${args.listingId}/orders/${args.orderId}/chat`,
        },
      },
    },
  },
  settings: {
    root: {
      path: 'settings',
      url: () => `${baseUrl}/settings`,
    },
    information: {
      path: 'information',
      url: () => `${baseUrl}/settings/information`,
    },
    account: {
      path: 'account',
      url: () => `${baseUrl}/settings/account`,
    },
    employees: {
      path: 'employees',
      url: () => `${baseUrl}/settings/employees`,
    },
  },
  help: {
    index: {
      path: 'help',
      url: () => `${baseUrl}/help`,
    },
  },
} as const satisfies AppRoutes;
